import React from 'react';

export default function shimmer() {
  return (
    <div className="phLiner">
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
